<div class="tsq-card" (click)="openImage()" *ngIf="!!file">
  <span>{{ file.name }}</span>
  <img src="./assets/libs/icons/download.svg" class="filter-primary" alt="">
</div>
